var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancel_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.995,
    height: 71.995,
    viewBox: "0 0 71.995 71.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_499",
    "data-name": "Trazado 499",
    d: "M0,0H72V72H0Z",
    fill: "none",
    opacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_500",
    "data-name": "Trazado 500",
    d: "M32,2A30,30,0,1,0,62,32,29.971,29.971,0,0,0,32,2ZM44.9,44.9a2.987,2.987,0,0,1-4.23,0L32,36.228,23.329,44.9a2.991,2.991,0,1,1-4.23-4.23L27.768,32,19.1,23.329a2.991,2.991,0,1,1,4.23-4.23L32,27.768,40.667,19.1a2.991,2.991,0,1,1,4.23,4.23L36.228,32,44.9,40.667a3.043,3.043,0,0,1,0,4.23Z",
    transform: "translate(4 4)",
    fill: "#f01e46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.3c878119f002bd3d0d4fb5e23127c060.svg";
export { ForwardRef as ReactComponent };